import React from 'react';
import styled from 'astroturf/react';
import { RenderElementProps, RenderLeafProps } from 'slate-react';
import { ParagraphElement } from './ParagraphElement';
import { TagElement } from './TagElement';
import { PaperLinkElement } from './PaperLinkElement';
import routes from 'js/core_pre_webpack/routes';
import { Link } from './Link';
import _Hashtag from "render-Hashtag.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/SocialEditor/render.tsx?styleId=Hashtag";


const Hashtag = /*#__PURE__*/styled(Link, null, {
  displayName: "Hashtag",
  styles: _Hashtag
});

/**
 * Render a Slate element to the editor.
 * Supports paragraph and tag elements currently.
 * @param props The element props.
 */
export function renderElement(props: RenderElementProps) {
  const elementMap = {
    paragraph: ParagraphElement,
    tag: TagElement,
    paper_link: PaperLinkElement,
  };
  const Element = elementMap[props.element.type] || ParagraphElement;
  return <Element {...props} />;
}

/**
 * Render a Slate leaf node to the editor.
 * Currently supports tags, hashtags, and plain text.
 * @param leaf The leaf node.
 * @param attributes The leaf attributes.
 * @param children Slate-provided leaf children.
 */
export function renderLeaf({ leaf, attributes, children }: RenderLeafProps) {
  if (leaf.link) {
    const link = leaf.link ?? '';
    return (
      <Link {...attributes} href={link} linked={leaf.readOnly !== false}>
        {children}
      </Link>
    );
  } else if (leaf.hashtag) {
    const hashtag = leaf.text.substring(1);
    const link = routes.community_hashtag_url({ hashtag });
    return (
      <Hashtag {...attributes} href={link}>
        {children}
      </Hashtag>
    );
  }
  return <span {...attributes}>{children}</span>;
}
